// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.GroupAvailableItem__container-e1105e {
  display: flex;
  align-items: center;
  padding-top: 8px;
  padding-bottom: 8px;
  padding-inline-start: 16px;
  padding-inline-end: 10px;
  box-sizing: border-box;
  cursor: pointer;
  text-decoration: none;
  background-color: var(--group-list-item-background);
  --group-list-item-background: var(--base-0);
}

.GroupAvailableItem__container-e1105e:hover {
  --group-list-item-background: var(--base-17);
}

.GroupAvailableItem__container-e1105e.GroupAvailableItem__active-e4ca37 {
  --group-list-item-background: var(--base-20);
}

.GroupAvailableItem__content-bc2ac3 {
  flex: 1;
  margin: 0 12px;
  overflow: hidden;
}

.GroupAvailableItem__title-b7c4b3 {
  font: var(--font-body-2);
  letter-spacing: var(--font-spacing-body-2);
  color: var(--base-110);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.GroupAvailableItem__title-wrapper-dbfeca {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  overflow: hidden;
}

.GroupAvailableItem__sub-title-a99895 {
  font: var(--font-subtitle-4);
  letter-spacing: var(--font-spacing-subtitle-4);
  color: var(--base-80);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}`, "",{"version":3,"sources":["webpack://./src/main/SidebarPanel/components/GroupAvailableItem/GroupAvailableItem.styles.m.css"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,mBAAA;EACA,0BAAA;EACA,wBAAA;EACA,sBAAA;EACA,eAAA;EACA,qBAAA;EACA,mDAAA;EAEA,2CAAA;AAAF;;AAGA;EACE,4CAAA;AAAF;;AAGA;EACE,4CAAA;AAAF;;AAGA;EACE,OAAA;EACA,cAAA;EACA,gBAAA;AAAF;;AAGA;EACE,wBAAA;EACA,0CAAA;EACA,sBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AAAF;;AAGA;EACE,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,gBAAA;AAAF;;AAGA;EACE,4BAAA;EACA,8CAAA;EACA,qBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AAAF","sourcesContent":[".container {\n  display: flex;\n  align-items: center;\n  padding-top: 8px;\n  padding-bottom: 8px;\n  padding-inline-start: 16px;\n  padding-inline-end: 10px;\n  box-sizing: border-box;\n  cursor: pointer;\n  text-decoration: none;\n  background-color: var(--group-list-item-background);\n\n  --group-list-item-background: var(--base-0);\n}\n\n.container:hover {\n  --group-list-item-background: var(--base-17);\n}\n\n.container.active {\n  --group-list-item-background: var(--base-20);\n}\n\n.content {\n  flex: 1;\n  margin: 0 12px;\n  overflow: hidden;\n}\n\n.title {\n  font: var(--font-body-2);\n  letter-spacing: var(--font-spacing-body-2);\n  color: var(--base-110);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.title-wrapper {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  overflow: hidden;\n}\n\n.sub-title {\n  font: var(--font-subtitle-4);\n  letter-spacing: var(--font-spacing-subtitle-4);\n  color: var(--base-80);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `GroupAvailableItem__container-e1105e`,
	"active": `GroupAvailableItem__active-e4ca37`,
	"content": `GroupAvailableItem__content-bc2ac3`,
	"title": `GroupAvailableItem__title-b7c4b3`,
	"title-wrapper": `GroupAvailableItem__title-wrapper-dbfeca`,
	"titleWrapper": `GroupAvailableItem__title-wrapper-dbfeca`,
	"sub-title": `GroupAvailableItem__sub-title-a99895`,
	"subTitle": `GroupAvailableItem__sub-title-a99895`
};
module.exports = ___CSS_LOADER_EXPORT___;
